/* Generated from Java with JSweet 2.3.7 - http://www.jsweet.org */
import { ExternalDocumentation } from '../../../core/models/common/ExternalDocumentation';
import { INamed } from '../../../core/models/common/INamed';
import { IVisitor } from '../../../core/visitors/IVisitor';
import { IOasPropertySchema } from '../../models/IOasPropertySchema';
import { OasSchema } from '../../models/OasSchema';
import { OasXML } from '../../models/OasXML';
import { IOas30Visitor } from '../visitors/IOas30Visitor';
import { IOasVisitor } from '../../visitors/IOasVisitor';

/**
 * Models an OpenAPI 3.0.x schema.
 * @author eric.wittmann@gmail.com
 * @class
 * @extends OasSchema
 */
export class Oas30Schema extends OasSchema {
    public oneOf : Array<OasSchema>;

    public anyOf : Array<OasSchema>;

    public not : OasSchema;

    public discriminator : Oas30Discriminator;

    public nullable : boolean;

    public writeOnly : boolean;

    public deprecated : boolean;

    /**
     * Creates a child Discriminator model.
     * @return {Oas30Discriminator} {Oas30Discriminator}
     */
    public createDiscriminator() : Oas30Discriminator {
        let rval : Oas30Discriminator = new Oas30Discriminator();
        rval._ownerDocument = this.ownerDocument();
        rval._parent = this;
        return rval;
    }

    /**
     * @see io.apicurio.datamodels.openapi.models.OasSchema#createExternalDocumentation()
     * @return {ExternalDocumentation}
     */
    public createExternalDocumentation() : ExternalDocumentation {
        let rval : ExternalDocumentation = new Oas30ExternalDocumentation();
        rval._ownerDocument = this.ownerDocument();
        rval._parent = this;
        return rval;
    }

    /**
     * @see io.apicurio.datamodels.openapi.models.OasSchema#createXML()
     * @return {OasXML}
     */
    public createXML() : OasXML {
        let rval : OasXML = new Oas30XML();
        rval._ownerDocument = this.ownerDocument();
        rval._parent = this;
        return rval;
    }

    /**
     * @see io.apicurio.datamodels.openapi.models.OasSchema#createAllOfSchema()
     * @return {OasSchema}
     */
    public createAllOfSchema() : OasSchema {
        let rval : Oas30Schema.Oas30AllOfSchema = new Oas30Schema.Oas30AllOfSchema();
        rval._ownerDocument = this.ownerDocument();
        rval._parent = this;
        return rval;
    }

    /**
     * @see io.apicurio.datamodels.openapi.models.OasSchema#createItemsSchema()
     * @return {OasSchema}
     */
    public createItemsSchema() : OasSchema {
        let rval : Oas30Schema.Oas30ItemsSchema = new Oas30Schema.Oas30ItemsSchema();
        rval._ownerDocument = this.ownerDocument();
        rval._parent = this;
        return rval;
    }

    /**
     * @see io.apicurio.datamodels.openapi.models.OasSchema#createAdditionalPropertiesSchema()
     * @return {OasSchema}
     */
    public createAdditionalPropertiesSchema() : OasSchema {
        let rval : Oas30Schema.Oas30AdditionalPropertiesSchema = new Oas30Schema.Oas30AdditionalPropertiesSchema();
        rval._ownerDocument = this.ownerDocument();
        rval._parent = this;
        return rval;
    }

    /**
     * @see io.apicurio.datamodels.openapi.models.OasSchema#createPropertySchema(java.lang.String)
     * @param {string} propertyName
     * @return {OasSchema}
     */
    public createPropertySchema(propertyName : string) : OasSchema {
        let rval : Oas30Schema.Oas30PropertySchema = new Oas30Schema.Oas30PropertySchema(propertyName);
        rval._ownerDocument = this.ownerDocument();
        rval._parent = this;
        return rval;
    }

    /**
     * Creates a child schema model.
     * @return {Oas30Schema.Oas30OneOfSchema}
     */
    public createOneOfSchema() : Oas30Schema.Oas30OneOfSchema {
        let rval : Oas30Schema.Oas30OneOfSchema = new Oas30Schema.Oas30OneOfSchema();
        rval._ownerDocument = this.ownerDocument();
        rval._parent = this;
        return rval;
    }

    /**
     * Creates a child schema model.
     * @return {Oas30Schema.Oas30AnyOfSchema}
     */
    public createAnyOfSchema() : Oas30Schema.Oas30AnyOfSchema {
        let rval : Oas30Schema.Oas30AnyOfSchema = new Oas30Schema.Oas30AnyOfSchema();
        rval._ownerDocument = this.ownerDocument();
        rval._parent = this;
        return rval;
    }

    /**
     * Creates a child schema model.
     * @return {Oas30Schema.Oas30NotSchema}
     */
    public createNotSchema() : Oas30Schema.Oas30NotSchema {
        let rval : Oas30Schema.Oas30NotSchema = new Oas30Schema.Oas30NotSchema();
        rval._ownerDocument = this.ownerDocument();
        rval._parent = this;
        return rval;
    }

    /**
     * Adds a OneOf schema.
     * @param {Oas30Schema.Oas30OneOfSchema} schema
     */
    public addOneOfSchema(schema : Oas30Schema.Oas30OneOfSchema) {
        if(this.oneOf == null) {
            this.oneOf = <any>([]);
        }
        /* add */(this.oneOf.push(schema)>0);
    }

    /**
     * Adds an AnyOf schema.
     * @param {Oas30Schema.Oas30AnyOfSchema} schema
     */
    public addAnyOfSchema(schema : Oas30Schema.Oas30AnyOfSchema) {
        if(this.anyOf == null) {
            this.anyOf = <any>([]);
        }
        /* add */(this.anyOf.push(schema)>0);
    }

    /**
     * Removes a oneOf schema.
     * @param {Oas30Schema.Oas30OneOfSchema} schema
     */
    public removeOneOfSchema(schema : Oas30Schema.Oas30OneOfSchema) {
        if(this.oneOf != null) {
            /* remove */(a => { let index = a.indexOf(schema); if(index>=0) { a.splice(index, 1); return true; } else { return false; }})(this.oneOf);
        }
    }

    /**
     * Removes a anyOf schema.
     * @param {Oas30Schema.Oas30AnyOfSchema} schema
     */
    public removeAnyOfSchema(schema : Oas30Schema.Oas30AnyOfSchema) {
        if(this.anyOf != null) {
            /* remove */(a => { let index = a.indexOf(schema); if(index>=0) { a.splice(index, 1); return true; } else { return false; }})(this.anyOf);
        }
    }

    constructor() {
        super();
        if(this.oneOf===undefined) this.oneOf = null;
        if(this.anyOf===undefined) this.anyOf = null;
        if(this.not===undefined) this.not = null;
        if(this.discriminator===undefined) this.discriminator = null;
        if(this.nullable===undefined) this.nullable = null;
        if(this.writeOnly===undefined) this.writeOnly = null;
        if(this.deprecated===undefined) this.deprecated = null;
    }
}
Oas30Schema["__class"] = "io.apicurio.datamodels.openapi.v3.models.Oas30Schema";
Oas30Schema["__interfaces"] = ["io.apicurio.datamodels.core.models.IVisitable","io.apicurio.datamodels.core.models.IReferenceNode","io.apicurio.datamodels.core.models.common.IExternalDocumentationParent"];



export namespace Oas30Schema {

    export class Oas30AdditionalPropertiesSchema extends Oas30Schema {
        /**
         * @see io.apicurio.datamodels.core.models.common.Schema#accept(io.apicurio.datamodels.core.visitors.IVisitor)
         * @param {*} visitor
         */
        public accept(visitor : IVisitor) {
            let viz : IOasVisitor = <IOasVisitor><any>visitor;
            viz.visitAdditionalPropertiesSchema(this);
        }

        constructor() {
            super();
        }
    }
    Oas30AdditionalPropertiesSchema["__class"] = "io.apicurio.datamodels.openapi.v3.models.Oas30Schema.Oas30AdditionalPropertiesSchema";
    Oas30AdditionalPropertiesSchema["__interfaces"] = ["io.apicurio.datamodels.core.models.IVisitable","io.apicurio.datamodels.core.models.IReferenceNode","io.apicurio.datamodels.core.models.common.IExternalDocumentationParent"];



    export class Oas30ItemsSchema extends Oas30Schema {
        /**
         * @see io.apicurio.datamodels.core.models.common.Schema#accept(io.apicurio.datamodels.core.visitors.IVisitor)
         * @param {*} visitor
         */
        public accept(visitor : IVisitor) {
            let viz : IOasVisitor = <IOasVisitor><any>visitor;
            viz.visitItemsSchema(this);
        }

        constructor() {
            super();
        }
    }
    Oas30ItemsSchema["__class"] = "io.apicurio.datamodels.openapi.v3.models.Oas30Schema.Oas30ItemsSchema";
    Oas30ItemsSchema["__interfaces"] = ["io.apicurio.datamodels.core.models.IVisitable","io.apicurio.datamodels.core.models.IReferenceNode","io.apicurio.datamodels.core.models.common.IExternalDocumentationParent"];



    export class Oas30AllOfSchema extends Oas30Schema {
        /**
         * @see io.apicurio.datamodels.core.models.common.Schema#accept(io.apicurio.datamodels.core.visitors.IVisitor)
         * @param {*} visitor
         */
        public accept(visitor : IVisitor) {
            let viz : IOasVisitor = <IOasVisitor><any>visitor;
            viz.visitAllOfSchema(this);
        }

        constructor() {
            super();
        }
    }
    Oas30AllOfSchema["__class"] = "io.apicurio.datamodels.openapi.v3.models.Oas30Schema.Oas30AllOfSchema";
    Oas30AllOfSchema["__interfaces"] = ["io.apicurio.datamodels.core.models.IVisitable","io.apicurio.datamodels.core.models.IReferenceNode","io.apicurio.datamodels.core.models.common.IExternalDocumentationParent"];



    export class Oas30NotSchema extends Oas30Schema {
        /**
         * @see io.apicurio.datamodels.core.models.common.Schema#accept(io.apicurio.datamodels.core.visitors.IVisitor)
         * @param {*} visitor
         */
        public accept(visitor : IVisitor) {
            let viz : IOas30Visitor = <IOas30Visitor><any>visitor;
            viz.visitNotSchema(this);
        }

        constructor() {
            super();
        }
    }
    Oas30NotSchema["__class"] = "io.apicurio.datamodels.openapi.v3.models.Oas30Schema.Oas30NotSchema";
    Oas30NotSchema["__interfaces"] = ["io.apicurio.datamodels.core.models.IVisitable","io.apicurio.datamodels.core.models.IReferenceNode","io.apicurio.datamodels.core.models.common.IExternalDocumentationParent"];



    export class Oas30OneOfSchema extends Oas30Schema {
        /**
         * @see io.apicurio.datamodels.core.models.common.Schema#accept(io.apicurio.datamodels.core.visitors.IVisitor)
         * @param {*} visitor
         */
        public accept(visitor : IVisitor) {
            let viz : IOas30Visitor = <IOas30Visitor><any>visitor;
            viz.visitOneOfSchema(this);
        }

        constructor() {
            super();
        }
    }
    Oas30OneOfSchema["__class"] = "io.apicurio.datamodels.openapi.v3.models.Oas30Schema.Oas30OneOfSchema";
    Oas30OneOfSchema["__interfaces"] = ["io.apicurio.datamodels.core.models.IVisitable","io.apicurio.datamodels.core.models.IReferenceNode","io.apicurio.datamodels.core.models.common.IExternalDocumentationParent"];



    export class Oas30AnyOfSchema extends Oas30Schema {
        /**
         * @see io.apicurio.datamodels.core.models.common.Schema#accept(io.apicurio.datamodels.core.visitors.IVisitor)
         * @param {*} visitor
         */
        public accept(visitor : IVisitor) {
            let viz : IOas30Visitor = <IOas30Visitor><any>visitor;
            viz.visitAnyOfSchema(this);
        }

        constructor() {
            super();
        }
    }
    Oas30AnyOfSchema["__class"] = "io.apicurio.datamodels.openapi.v3.models.Oas30Schema.Oas30AnyOfSchema";
    Oas30AnyOfSchema["__interfaces"] = ["io.apicurio.datamodels.core.models.IVisitable","io.apicurio.datamodels.core.models.IReferenceNode","io.apicurio.datamodels.core.models.common.IExternalDocumentationParent"];



    /**
     * Constructor.
     * @param {string} propertyName
     * @class
     * @extends Oas30Schema
     */
    export class Oas30PropertySchema extends Oas30Schema implements IOasPropertySchema, INamed {
        _propertyName : string;

        public constructor(propertyName : string) {
            super();
            if(this._propertyName===undefined) this._propertyName = null;
            this._propertyName = propertyName;
        }

        /**
         * @see io.apicurio.datamodels.openapi.models.IOasPropertySchema#getPropertyName()
         * @return {string}
         */
        public getPropertyName() : string {
            return this._propertyName;
        }

        /**
         * 
         * @return {string}
         */
        public getName() : string {
            return this._propertyName;
        }

        /**
         * @see io.apicurio.datamodels.openapi.models.IOasPropertySchema#rename(java.lang.String)
         * @param {string} newName
         */
        public rename(newName : string) {
            this._propertyName = newName;
        }

        /**
         * @see io.apicurio.datamodels.core.models.common.Schema#accept(io.apicurio.datamodels.core.visitors.IVisitor)
         * @param {*} visitor
         */
        public accept(visitor : IVisitor) {
            let viz : IOasVisitor = <IOasVisitor><any>visitor;
            viz.visitPropertySchema(<IOasPropertySchema><any>this);
        }
    }
    Oas30PropertySchema["__class"] = "io.apicurio.datamodels.openapi.v3.models.Oas30Schema.Oas30PropertySchema";
    Oas30PropertySchema["__interfaces"] = ["io.apicurio.datamodels.openapi.models.IOasPropertySchema","io.apicurio.datamodels.core.models.IVisitable","io.apicurio.datamodels.core.models.IReferenceNode","io.apicurio.datamodels.core.models.common.INamed","io.apicurio.datamodels.core.models.common.IExternalDocumentationParent"];


}




import { Oas30XML } from './Oas30XML';


import { Oas30ExternalDocumentation } from './Oas30ExternalDocumentation';


import { Oas30Discriminator } from './Oas30Discriminator';

